import API from "../../../../../global/api";


export const requestAddFBRCompany = () => {
    return {
        type: "REQUEST_ADD_FBR_COMPANY",
    };
};
export const successAddFBRCompany = (data) => {
    return {
        type: "SUCCESS_ADD_FBR_COMPANY",
        payload: data,
    };
};
export const errorAddFBRCompany = () => {
    return {
        type: "ERROR_ADD_FBR_COMPANY",
    };
};
export const AddFBRCompanyApi = (data, showSuccessAlert, showErrorAlert) => {
    return (dispatch) => {
        dispatch(requestAddFBRCompany());
        API.post(`/FBRInvoice/add-company`, data).then((res) => {
            dispatch(successAddFBRCompany(data));
            showSuccessAlert(res.data.message);
        }).catch((error) => {
            dispatch(errorAddFBRCompany());
            showErrorAlert(error.response.data.message || "Something went wrong");
        })
    };
};


export const requestGetFBRCompany = () => {
    return {
        type: "REQUEST_GET_FBR_COMPANY",
    };
};
export const successGetFBRCompany = (data) => {
    return {
        type: "SUCCESS_GET_FBR_COMPANY",
        payload: data,
    };
};
export const errorGetFBRCompany = () => {
    return {
        type: "ERROR_GET_FBR_COMPANY",
    };
};
export const GetFBRCompanyApi = () => {
    return (dispatch) => {
        dispatch(requestGetFBRCompany());
        API.get(`/FBRInvoice/get-companies?page=0&limit=1000`).then((res) => {
            let getData = res.data;
            dispatch(successGetFBRCompany(getData));
        }).catch((error) => {
            dispatch(errorGetFBRCompany());
        })
    };
};


export const DeleteRequestFBRComapny = () => {
    return {
        type: "DELETE_REQUEST_FBR_COMPANY",
    };
};
export const DeleteSuccessFBRComapny = (companyId) => {
    return {
        type: "DELETE_SUCCESS_FBR_COMPANY",
        companyId: companyId,
    };
};
export const DeleteErrorFBRComapny = () => {
    return {
        type: "DELETE_ERROR_FBR_COMPANY",
    };
};
export const DeleteFBRCompanyApi = (companyId) => {
    return dispatch => {
        dispatch(DeleteRequestFBRComapny());
        API.delete(`/FBRInvoice/delete-company/${companyId}`).then(res => {
            dispatch(DeleteSuccessFBRComapny(companyId))
        }).catch((error) => {
            dispatch(DeleteErrorFBRComapny())
        });
    }
};


export const UpdateRequestRestaurant = () => {
    return {
        type: "UPDATE_REQUEST_RESTAURANT",
    };
};
export const UpdateSuccessRestaurant = (data) => {
    return {
        type: "UPDATE_SUCCESS_RESTAURANT",
        payload: data,
    };
};
export const UpdateErrorRestaurant = () => {
    return {
        type: "UPDATE_ERROR_RESTAURANT",
    };
};
export const updateRestaurant = (data, oldData) => {
    return dispatch => {
        dispatch(UpdateRequestRestaurant());
        API.put(`/company/update-company/${oldData._id}`, {
            restaurantName: data.restaurantName,
            restaurantLocation: data.restaurantLocation,
            restaurantDesc: data.restaurantDesc,
            tax: data.tax,
            ntn: data.ntn,
            taxType: data.taxType,
            praTaxCash: data.praTaxCash,
            praTaxCard: data.praTaxCard,
            fbrTaxCash: data.fbrTaxCash,
            fbrTaxCard: data.fbrTaxCard,
            email: data.email,
            phone: data.phone,
            strn: data.strn,
        }, {
        }).then(res => {
            dispatch(UpdateSuccessRestaurant([data]))
        }).catch((error) =>
            dispatch(UpdateErrorRestaurant()));
    }
};